import Nav from '@src/routes';

import { useAppliedViewIdStore } from './useApplySavedViewFilters';
import { SAVED_VIEW_SEARCH_PARAM } from './useSavedViewUrlSelection';

// The listing re-syncs the store with the URL on every visit, so inside a contract it still holds the origin view.
export const useContractsListingBackPath = (): string => {
  const appliedViewId = useAppliedViewIdStore((state) => state.appliedViewId);
  return appliedViewId ? `${Nav.Submissions}?${SAVED_VIEW_SEARCH_PARAM}=${appliedViewId}` : Nav.Submissions;
};
